import { InfoOutlined } from '@mui/icons-material';
import { Box, alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Typography from '../../../components/Typography/Typography';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';

const useStyles = makeStyles()((theme) => ({
  updateConditionsWarning: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '8px 12px',
    backgroundColor: theme.palette.info.light,
    border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
    borderRadius: 8,
  },
  infoIcon: {
    fontSize: 15,
    color: theme.palette.info.main,
  },
}));

const UpdateConditionsAndPricesWarning = () => {
  const { classes } = useStyles();
  const { translate } = useTranslation();
  return (
    <Box className={classes.updateConditionsWarning}>
      <InfoOutlined className={classes.infoIcon} />
      <Typography variant="body2.5-medium">
        <span style={{ fontWeight: 700, letterSpacing: '0.17px' }}>
          {translate(LangEnum.GLOBAL_UPDATE_IS_IRREVERSIBLE)}:{' '}
        </span>
        {translate(LangEnum.ORDER_MASS_ACTIONS_UPDATE_CONDITIONS_WARNING)}
      </Typography>
    </Box>
  );
};

export default UpdateConditionsAndPricesWarning;
